import {sendUpdateNumSelectedEvent} from './send-update-num-selected-event.js'
import {updateSelected} from './update-selected.js'
import {processText} from '../new-vpo-page/select-cads/process-text.js'
import {parseDate} from './vpo-sort'
import {unminifyBrand, unminifyDivision, unminifyCategory} from '../cads/unminify'
import {needsTickets} from '../purchase-orders/needs-tickets'


const filterVendorOrders = (myState) => {
  let {vendorOrders, archivedVpos} = window
  let {status, payments, factory, buyer, brand, division, category, searchString, fromDate, toDate, showBulk, showEditedOn, rep} = myState
  let filteredVendorOrders = []

  let searchStrings = (showBulk ? processText(searchString) : [])
  let usingNonStatusFilters = (payments.length || factory.length || buyer.length || brand.length || division.length || category.length || searchString != '' || fromDate != null || toDate != null || rep.length)

  //'Ticketed' is a pseudo-status: it filters on tickets, not on x.status
  let ticketedOnly = status.includes('Ticketed')
  let realStatuses = status.filter(s => s != 'Ticketed')

  if (status.length || usingNonStatusFilters || showEditedOn) {
    let isSearching = (searchStrings.length > 0 && searchStrings[0] != '')

    if (realStatuses.includes('Shipped') || realStatuses.includes('Cancelled') || isSearching) {
      filteredVendorOrders = filteredVendorOrders.concat(archivedVpos)
    }

    if (realStatuses.includes('Pending') || realStatuses.includes('Processed') || realStatuses.includes('QB-Entered') || realStatuses.includes('Ready-To-Ship') || isSearching || usingNonStatusFilters || showEditedOn || ticketedOnly) {
      filteredVendorOrders = filteredVendorOrders.concat(vendorOrders)
    }

    if (realStatuses.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => realStatuses.indexOf(x.status) > -1)
    }

    if (ticketedOnly) {
      filteredVendorOrders = filteredVendorOrders.filter(x => needsTickets(x.ticketed))
    }

    if (payments.includes('PAID')) {
      filteredVendorOrders = filteredVendorOrders.filter(x => x.time_paid != null)
    }

    if (payments.includes('UNPAID')) {
      filteredVendorOrders = filteredVendorOrders.filter(x => x.time_paid == null)
    }

    if (factory.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => factory.indexOf(x.factory_id) > -1)
    }

    if (buyer.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => buyer.indexOf(x.buyer_name == null ? 'Pending' : x.buyer_name) > -1)
    }

    if (brand.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => brand.map(x => x.split(' = ')[1]).includes(unminifyBrand(x.cad.b)))
    }

    if (division.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => division.map(x => x.split(' = ')[1]).includes(unminifyDivision(x.cad.d)))
    }

    if (category.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => category.map(x => x.split(' = ')[1]).includes(unminifyCategory(x.cad.g)))
    }

    if (isSearching) {
      filteredVendorOrders = filteredVendorOrders.filter(x => searchStrings.includes(x.refnumber) || searchStrings.includes(x.refnumber.replace('V','')) || searchStrings.includes(x.vponumber) || searchStrings.includes(x.style_number) || searchStrings.includes(x.transaction_id) || (x.pending_container_number != null && x.pending_container_number.split(',').map(s => s.trim()).some(c => searchStrings.includes(c))))
    }

    if (fromDate != null) {
      filteredVendorOrders = filteredVendorOrders.filter(x => dateFormatSlashToDash(x.ex_factory) >= fromDate)
    }

    if (toDate != null) {
      filteredVendorOrders = filteredVendorOrders.filter(x => dateFormatSlashToDash(x.ex_factory) <= toDate)
    }

    if (showEditedOn) {
      // let d = new Date()
      // d.setDate(d.getDate() - 10)
      // filteredVendorOrders = filteredVendorOrders.filter(x => x.edited && parseDate(x.edited_on) > d)
      filteredVendorOrders = filteredVendorOrders.filter(x => x.edited)
    }

    if (rep.length) {
      filteredVendorOrders = filteredVendorOrders.filter(x => rep.includes(x.sales_rep_id))
    }

    window.filteredVendorOrders = filteredVendorOrders
  } else {
    window.filteredVendorOrders = undefined
  }
  afterFilterChange()

  let statuses = []
  if (showBulk) {
    let duplicates = {}

    searchStrings.forEach((element, index) => {
      if (element == '') {
        statuses.push(null)
      } else {
        if (duplicates[element]) {
          statuses.push('duplicate')
        } else {
          if (filteredVendorOrders.some(x => element == x.refnumber || element == x.refnumber.replace('V','') || element == x.vponumber || element == x.style_number || element == x.transaction_id)) {
            statuses.push('found')
          } else {
            statuses.push('not found')
          }

          duplicates[element] = true
        }
      }
    })
  }

  return statuses
}

const afterFilterChange = () => {
  window.vpoIds = {}
  sendUpdateNumSelectedEvent()
  updateSelected()
}

const dateFormatSlashToDash = (dateString) => {
  let parts = dateString.split('/')
  return  parts[2] + '-' + parts[0].padStart(2, '0') + '-' + parts[1].padStart(2, '0')
}

export default filterVendorOrders
